import React from "react";
import ReactDOM from "react-dom/client";
import { Router } from "./components/Router";
import "./index.css";
import { Analytics } from "@vercel/analytics/react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Router />
    <Analytics />
  </React.StrictMode>,
);
